'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (name, token) {
	if (!token) {
		throw new TypeError('illegal rule token');
	}
	return '<' + name + '> = ' + token;
};


//////////////////
// WEBPACK FOOTER
// ./~/jspeech/lib/stringify/types/rule.js
// module id = 63
// module chunks = 0